import {
  defaultColorResolver,
  type ColorResolver,
} from 'src/components/atlas/organisms/helpers/sharedStatusColorResolvers';

// Explicit hex to match the Figma status badges exactly: Active = light green
// fill with dark green text, Retired = light red fill with dark red text. The
// Lens accent tokens don't resolve to these shades on the StatusIndicator, so
// the values are set directly here.
const activeColorResolver: ColorResolver = () => ({
  backgroundColor: '#E7F4EC',
  color: '#17663B',
});

const retiredColorResolver: ColorResolver = () => ({
  backgroundColor: '#FBEAEA',
  color: '#B42318',
});

const STATUS_COLOR_RESOLVERS: Record<string, ColorResolver> = {
  ACTIVE: activeColorResolver,
  RETIRED: retiredColorResolver,
  INACTIVE: retiredColorResolver,
};

export const customFieldStatusColorMap = (status: string): ColorResolver =>
  STATUS_COLOR_RESOLVERS[status] ?? defaultColorResolver;
